const vendorProviderType = (() => {
    let vendorID;  
    let providerTypeEntries;
    let providerTypePopup;
    let providerTypeDropdownData;
    let oTable;

    async function init(vendorId) {
        vendorID = vendorId;       
        providerTypeEntries = await authorizationsAjax.getProviderTypeEntriesAsync(vendorID);
        providerTypeDropdownData = await authorizationsAjax.getProviderTypeDropdownData();
    }

    function getMarkup() {
        const vendorProviderWrap = document.createElement('div');
        vendorProviderWrap.classList.add('planSummary');

        const importantTables = buildNewVendorProviderTypeForm();
        vendorProviderWrap.appendChild(importantTables);
        
        return vendorProviderWrap;
    }

    function buildNewVendorProviderTypeForm() {
        const vendorProviderDiv = document.createElement('div');
        vendorProviderDiv.classList.add('additionalQuestionWrap');

        providerTypeEntriesTable = buildProviderTypeEntriesTable();

        const headers = providerTypeEntriesTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string'); // Provider Type
        headers[1].setAttribute('data-type', 'date'); // Start Date
        headers[2].setAttribute('data-type', 'date'); // End Date 
        headers[3].setAttribute('data-type', 'string'); // Notes 

        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">Provider Type</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        addNewCardBody.appendChild(providerTypeEntriesTable);
        vendorProviderDiv.appendChild(column1);

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(providerTypeEntriesTable); 

        return vendorProviderDiv;
    }

    function buildProviderTypeEntriesTable() {
        const tableOptions = {
            plain: false,
            tableId: 'vendorInfoTable',
            columnHeadings: ['Provider Type', 'Start Date', 'End Date', 'Notes'],
            endIcon: false,
            callback: function (event) {
                if (event.target.childNodes[0].innerText == undefined) return;
                var providerType = event.target.getAttribute('providertype');
                var startDate = event.target.getAttribute('startdate');
                var endDate = event.target.getAttribute('enddate');
                var notes = event.target.childNodes[3].innerText;
                showNewProviderTypePopup({
                    providerType: providerType,
                    startDate: moment(startDate).format('YYYY-MM-DD'),
                    endDate: endDate === '' ? '' : moment(endDate).format('YYYY-MM-DD'),
                    notes: notes
                });
            },
        };
        oTable = table.build(tableOptions);
        populateTable();
        return oTable;
    }
    function populateTable() {
        let tableData = providerTypeEntries.getProviderTypeEntriesResult.map(entry => {
            let startDateFormatted = moment(entry.startDate).format('MM/DD/YYYY');
            let endDateFormatted = entry.endDate == '' ? '' : moment(entry.endDate).format('MM/DD/YYYY');
           return {
                providerType: entry.providerTypeCode,
                attributes: [{ key: 'providertype', value: entry.providerTypeCode }, { key: 'startdate', value: entry.startDate }, { key: 'endDate', value: entry.endDate }],
                values: [entry.ProviderType, startDateFormatted, endDateFormatted, entry.Notes],
           }
        });

        table.populate(oTable, tableData);           
    }
    function showNewProviderTypePopup(data) {
        let providerType = data?.providerType||null;
        let startDateValue = data?.startDate||null;
        let endDateValue = data?.endDate||null;
        let notes = data?.notes||null;
        let saveOrUpdate = data ? 'update' : 'save';
        let isReadOnly = false;

        if (!data) {
            if ($.session.authorizationInsertVendorInfo) isReadOnly = false;
            else if (!$.session.authorizationInsertVendorInfo) isReadOnly = true;
        }
        else if (data) {
            if ($.session.authorizationsVendorInfoUpdate) isReadOnly = false;
            else if (!$.session.authorizationsVendorInfoUpdate) isReadOnly = true;
        }

        providerTypePopup = POPUP.build({
            header: data? 'Edit Provider Type': 'New Provider Type',
            id: 'providerTypePopup',
        });

        const providerTypeDropdown = dropdown.build({
            id: 'providerTypeDropdown',
            label: 'Provider Type',
            dropdownId: 'providerTypeDropdown', 
            readonly: isReadOnly
        });
        const providerTypes = JSON.parse(providerTypeDropdownData.getProviderTypeDropdownDataResult)||[];
        var defaultDropdownOption = { value: '', text: '' };
        providerTypes.unshift(defaultDropdownOption);
        dropdown.populate(providerTypeDropdown, providerTypes, data?.providerType|| '');

        const startDate = input.build({
            label: 'Start Date',
            type: 'date',
            style: 'secondary',             
            value: data?.startDate,
            readonly: isReadOnly
        });
        const endDate = input.build({
            label: 'End Date',
            type: 'date',
            style: 'secondary',
            value: data?.endDate,
            readonly: isReadOnly
        });
        const noteInput = input.build({
            label: 'Notes',
            type: 'textarea',
            style: 'secondary',
            value: data?.notes||'',
            charLimit: 1000,
            forceCharLimit: true,
            readonly: isReadOnly
        });

        const saveBtn = button.build({
            id: 'providerTypeSave',
            text: data ? 'Apply' : 'Save', 
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                const result = await authorizationsAjax.saveProviderType({
                    vendorId: vendorID,
                    providerType: providerType,
                    startDate: startDateValue,
                    endDate: endDateValue,
                    notes: notes,
                    saveOrUpdate: saveOrUpdate,
                    oldStartDate: data?.startDate || null,
                    oldProviderType: data?.providerType || null,
                });
                const saveResult = result.saveProviderTypeResult;
                if (saveResult === 'success') {
                    POPUP.hide(providerTypePopup);
                    successfulSave.show(data ? 'Updated' : 'Saved');                    
                    setTimeout(function () {
                        successfulSave.hide();
                    }, 2000);
                    providerTypeEntries = await authorizationsAjax.getProviderTypeEntriesAsync(vendorID);
                    populateTable();
                }
                else if (saveResult === 'exists') {
                    POPUP.hide(providerTypePopup);
                    showAlreadyExistsWarning();                   
                }               
            },
        });
        const cancelBtn = button.build({
            id: 'providerTypeCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(providerTypePopup);
            },
        });
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        if (!isReadOnly) {
            btnWrap.appendChild(saveBtn);
        }
        btnWrap.appendChild(cancelBtn);

        providerTypePopup.appendChild(providerTypeDropdown);
        const dateWrap = document.createElement('div');
        dateWrap.style.display = 'grid';
        dateWrap.style.gridTemplateColumns = '1fr 1fr';
        dateWrap.style.gap = '10px';
        dateWrap.style.marginBottom = '10px';
        dateWrap.style.width = '100%';
        dateWrap.appendChild(startDate);
        dateWrap.appendChild(endDate);       
        providerTypePopup.appendChild(dateWrap); 
        const errorMsg = document.createElement('p');
        errorMsg.style.display = 'none';
        errorMsg.style.marginBottom = '15px';
        errorMsg.style.marginTop = '-15px';
        errorMsg.style.color = 'red';
        errorMsg.textContent = 'Start Date cannot be greater than the End Date';
        providerTypePopup.appendChild(errorMsg);
        providerTypePopup.appendChild(noteInput);
        providerTypePopup.appendChild(btnWrap);
        POPUP.show(providerTypePopup);
        validatePopupFields();

        providerTypeDropdown.addEventListener('change', function (e) {
            providerType = e.target.value;
            validatePopupFields();
        });
        startDate.addEventListener('change', function (e) {
            startDateValue = e.target.value;
            validatePopupFields();            
        });
        endDate.addEventListener('change', function (e) {
            endDateValue = e.target.value === '' ? null : e.target.value;     
            validatePopupFields();
        });
        noteInput.addEventListener('input', function (e) {
            notes = e.target.value;   
            validatePopupFields();
        });
        function validatePopupFields() {
            if (providerType === null || providerType === '') {
                providerTypeDropdown.classList.add('error');
            }
            else {
                providerTypeDropdown.classList.remove('error');
            }
            if (startDateValue === null || startDateValue === '') {
                startDate.classList.add('error');
            }
            else {
                startDate.classList.remove('error');
            }
            errorMsg.style.display = 'none';
            if ((startDateValue !== null && endDateValue !== null) && startDateValue > endDateValue) {
                errorMsg.style.display = 'block';              
            } 
           
            var providerTypePopupDiv = document.getElementById('providerTypePopup');
            var hasErrors = [].slice.call(providerTypePopupDiv.querySelectorAll('.error:not(button)'));
            if (hasErrors.length === 0) {               
                saveBtn.classList.remove('disabled');
                const newData = { providerType, startDate: startDateValue, endDate: endDateValue || '', notes: notes || '' };
                const isChanged = data && JSON.stringify(data) !== JSON.stringify(newData);                
                if (errorMsg.style.display === 'block' || (data && !isChanged)) {
                    saveBtn.classList.add('disabled');
                }
            } else {
                saveBtn.classList.add('disabled');
            }
        }
        function showAlreadyExistsWarning() {
            var warningPopup = POPUP.build({});
            warningPopup.classList.add('warning');
            var message = document.createElement('p');
            message.innerHTML = 'This Provider Type overlaps with an existing Provider Type.';
            message.style.marginBottom = '15px';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var okBtn = button.build({
                text: 'Ok',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(warningPopup);
                    //const overlay = document.querySelector('.overlay');
                    //overlay.classList.add('visible');
                    POPUP.show(providerTypePopup);
                }
            });

            btnWrap.appendChild(okBtn);
            warningPopup.appendChild(message);
            warningPopup.appendChild(btnWrap);
            POPUP.show(warningPopup);
            warningPopup.querySelector('.closePopupBtn').remove();
        }      
    }
   
    return {
        init,
        buildNewVendorProviderTypeForm,
        getMarkup,
        populateTable,
        showNewProviderTypePopup,
    };
})(); 
